import type { TourStep } from '../types';

export const accountSecuritySteps: TourStep[] = [
  {
    target: '[data-tour="settings-tabs"]',
    title: 'Settings Overview',
    content:
      'Settings has several tabs — Billing, Account, Preferences, Sessions, Addenda Presets, and E&O Rules. Let\'s focus on security.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="settings-account"]',
    title: 'Account Details',
    content:
      'Your login email, connected sign-in methods (email/password, Google), and account management options live here.',
    placement: 'bottom',
    route: '/settings',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="settings-2fa"]',
    title: 'Enable Two-Factor Auth',
    content:
      'Add an extra layer of security. When enabled, you\'ll need a code from your authenticator app each time you log in. We strongly recommend this.',
    placement: 'bottom',
    route: '/settings',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ll set this up',
  },
  {
    target: '[data-tour="settings-password"]',
    title: 'Update Your Password',
    content:
      'Change your password anytime. The strength indicator helps you pick a strong one — aim for a mix of uppercase, lowercase, numbers, and symbols.',
    placement: 'bottom',
    route: '/settings',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="settings-preferences"]',
    title: 'Preferences',
    content:
      'Configure your file number format scheme and calendar reminder settings. These apply across all your appraisals and events.',
    placement: 'bottom',
    route: '/settings',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="settings-sessions"]',
    title: 'Session History',
    content:
      'Review recent logins — device types, locations, timestamps. If you spot an unfamiliar session, revoke it immediately to protect your account.',
    placement: 'bottom',
    route: '/settings',
    spotlightClicks: true,
  },
];
